// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body{overflow:hidden}*{box-sizing:border-box;font-family:\"InterDisplay\",sans-serif}button:focus{outline:none}a:hover{color:inherit}", "",{"version":3,"sources":["webpack://src/client/css/global.scss"],"names":[],"mappings":"AAAA,KAEI,eAAA,CAGJ,EACI,qBAAA,CACA,qCAAA,CAGJ,aACI,YAAA,CAGJ,QACI,aAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
